export default __webpack_public_path__ + "Fascia_3_Single.png";